import { render, staticRenderFns } from "./buttons-text.vue?vue&type=template&id=fb18a72e&scoped=true&"
import script from "./buttons-text.vue?vue&type=script&lang=js&"
export * from "./buttons-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb18a72e",
  null
  
)

export default component.exports